import { httpCreate } from './http';

const http = httpCreate('/srv/certification');

export const certification = {
	/**
	 * @param { Number } data.type require:true             认证类型 0-个人 1-企业
	 * @param { String } data.name require:true             联系人/姓名
	 * @param { String } data.mobPhone require:true         联系电话
	 * @param { String } data.address require:true          联系地址
	 * @param { String } data.detailAddress require:false   详细地址
	 * @param { Number } data.companySize require:true      企业规模
	 * @param { String } data.companyName require:true      公司名称，限制20字符
	 * @param { String } data.companySocialCode require:true        统一社会信用代码
	 * @param { String } data.companyBusinessLicense require:true   营业执照
	 * @param { String } data.personalWechatNum require:true        微信号
	 * @param { String } data.personalIdCard require:true           身份证号
	 * @param { String } data.personalIdCardFront require:true      身份证正面
	 * @param { String } data.personalIdCardReverse require:true    身份证反面
	 */
	submit(params, data) {
		return http.post(`/`, data, { params });
	},
	getIsAuthentication() {
		return http.get('/giveFluxPop');
	},
	// 已废弃
	// getCertificationInfo(id) {
	//     return http.get(`/${id}`);
	// }
};
